import { Menu, Row, Col, Button, Space, Drawer, Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import { MenuOutlined, DownOutlined } from '@ant-design/icons';

function AppHeader() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState('home');
  const [visible, setVisible] = useState(false);

  const onMenuClick = (menu) => {
    setCurrent(menu.key);
    navigate(`/${menu.key}`);
    setVisible(false);
  };

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const solutionsMenu = (
    <Menu
      onClick={onMenuClick}
      items={[
        {
          label: 'Retail Stores',
          key: 'solutions/retail',
        },
        {
          label: 'Restaurants',
          key: 'solutions/restaurants',
        },
        {
          label: 'Wholesale',
          key: 'solutions/wholesale',
        },
      ]}
    />
  );

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      background: 'rgba(255, 255, 255, 0.98)',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
      backdropFilter: 'blur(8px)',
      borderBottom: '1px solid rgba(0, 0, 0, 0.05)'
    }}>
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto',
        padding: '0 24px'
      }}>
        <Row align="middle" justify="space-between">
          <Col>
            <div 
              style={{ 
                display: 'flex', 
                alignItems: 'center',
                height: '80px',
                cursor: 'pointer'
              }}
              onClick={() => {
                navigate('/in-touch');
                setCurrent('in-touch');
              }}
            >
              <img
                src="/images/sell-smart-logo.png"
                alt="SellSmart Logo"
                style={{
                  height: '36px',
                  width: 'auto',
                  marginRight: '8px'
                }}
              />
              <span style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#0d306d'
              }}>
                SellSmart
              </span>
            </div>
          </Col>
          
          <Col className="desktop-menu">
            <Space size="large" align="center" style={{ height: '80px' }}>
              <Button 
                type="text" 
                size="large"
                onClick={() => {
                  navigate('/in-touch');
                  setCurrent('in-touch');
                }}
                style={{
                  fontWeight: '500',
                  color: current === 'in-touch' ? '#ff4f2e' : '#0d306d',
                  fontSize: '15px'
                }}
              >
                Home
              </Button>
              <Button 
                type="text" 
                size="large"
                 onClick={() => {
                  navigate('/in-touch');
                  setCurrent('in-touch');
                }}
                style={{
                  fontWeight: '500',
                  color: current === 'features' ? '#ff4f2e' : '#0d306d',
                  fontSize: '15px'
                }}
              >
                Features
              </Button>
              <Button 
                type="text" 
                size="large"
                onClick={() => {
                  navigate('/in-touch/pricing');
                  setCurrent('pricing');
                }}
                style={{
                  fontWeight: '500',
                  color: current === 'pricing' ? '#ff4f2e' : '#0d306d',
                  fontSize: '15px'
                }}
              >
                Pricing
              </Button>
              
              <Dropdown overlay={solutionsMenu} placement="bottomLeft">
                <Button 
                  type="text" 
                  size="large"
                  style={{
                    fontWeight: '500',
                    color: current.includes('solutions') ? '#ff4f2e' : '#0d306d',
                    fontSize: '15px'
                  }}
                >
                  {/* <Space>
                    Solutions
                    <DownOutlined style={{ fontSize: 12 }} />
                  </Space> */}
                </Button>
              </Dropdown>
            </Space>
          </Col>
          
          <Col className="desktop-menu">
            <Space size="middle">
              <Button 
                type="text" 
                size="large"
                onClick={() => {
                  navigate("/login");
                  setCurrent('');
                }}
                style={{
                  fontWeight: '500',
                  color: '#0d306d'
                }}
              >
                Sign In
              </Button>
              <Button 
                type="primary" 
                size="large"
                onClick={() => {
                  navigate("/in-touch/register");
                  setCurrent('');
                }}
                style={{
                  fontWeight: '500',
                  background: '#ff4f2e',
                  border: 'none',
                  boxShadow: '0 2px 8px rgba(255, 79, 46, 0.2)'
                }}
              >
                Get Started
              </Button>
            </Space>
          </Col>

          <Col className="mobile-menu">
            <Button 
              type="text" 
              icon={<MenuOutlined />}
              onClick={showDrawer}
              style={{
                fontSize: '20px',
                color: '#0d306d',
                height: '48px',
                width: '48px'
              }}
            />
          </Col>
        </Row>
      </div>

      {/* Mobile Drawer */}
      <Drawer
        title={
          <div 
            style={{ 
              display: 'flex', 
              alignItems: 'center',
              cursor: 'pointer'
            }}
            onClick={() => {
              navigate('/in-touch');
              setCurrent('in-touch');
              onClose();
            }}
          >
            <img
              src="/images/sell-smart-logo.png"
              alt="SellSmart Logo"
              style={{
                height: '28px',
                width: 'auto',
                marginRight: '8px'
              }}
            />
            <span style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#0d306d'
            }}>
              SellSmart
            </span>
          </div>
        }
        placement="right"
        onClose={onClose}
        open={visible}
        width={280}
        bodyStyle={{ padding: 0 }}
        headerStyle={{ padding: '16px 24px' }}
      >
        <Menu
          onClick={onMenuClick}
          selectedKeys={[current]}
          mode="inline"
          style={{
            borderRight: 'none',
            padding: '8px 0'
          }}
          items={[
            {
              label: 'Home',
              key: 'in-touch',
            },
            {
              label: 'Features',
              key: 'in-touch',
            },
            {
              label: 'Pricing',
              key: 'in-touch/pricing',
            },
          ]}
        />
        <div style={{ 
          padding: '24px',
          borderTop: '1px solid rgba(0, 0, 0, 0.06)'
        }}>
          <Button 
            type="primary" 
            block
            size="large"
            onClick={() => {
              navigate("/in-touch/register");
              onClose();
            }}
            style={{
              fontWeight: '500',
              background: '#ff4f2e',
              border: 'none',
              marginBottom: '16px',
              height: '42px'
            }}
          >
            Get Started
          </Button>
          <Button 
            type="text" 
            block
            size="large"
            onClick={() => {
              navigate("/login");
              onClose();
            }}
            style={{
              fontWeight: '500',
              color: '#0d306d',
              height: '42px'
            }}
          >
            Sign In
          </Button>
        </div>
      </Drawer>

      <style jsx global>{`
        @media (max-width: 992px) {
          .desktop-menu {
            display: none !important;
          }
          .mobile-menu {
            display: block !important;
          }
        }
        @media (min-width: 993px) {
          .mobile-menu {
            display: none !important;
          }
        }
        .ant-btn-text:hover {
          color: #ff4f2e !important;
        }
      `}</style>
    </header>
  );
}

export default AppHeader;